import { makeFileURL } from 'lib/s3/s3Helper';
import {
  fileOf,
  type PinFileFields,
  type PinRendererProps
} from './pinMediaRenderer';

/** The stored file's address, as the pinboard reads it: only a file with its id has one. */
function storedFileUrl(file: PinFileFields | undefined): string {
  return file && typeof file.id === 'number' && typeof file.url === 'string'
    ? makeFileURL({ ...file, id: file.id, url: file.url })
    : '';
}

export function FilePin({ pin }: PinRendererProps) {
  const file = fileOf(pin);
  const href = storedFileUrl(file) || pin.url || undefined;
  const extension = file?.mime_type ? file.mime_type.split('/').pop() : 'File';
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex w-56 max-w-full flex-col items-center gap-3 rounded-xl bg-bg-subtle p-8 text-center hover:bg-bg-inset"
    >
      <span className="text-sm font-semibold uppercase text-fg-muted">
        {extension}
      </span>
      <span className="break-all text-sm text-fg-default">{file?.name}</span>
    </a>
  );
}
